// extracted by mini-css-extract-plugin
module.exports = {"input":"delete-category_input_2uRtm","inputContainer":"delete-category_inputContainer_2FW7L"};